var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInformation = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 20,
  width: 20,
  viewBox: "2 2 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z",
  strokeWidth: 1,
  fillRule: "evenodd"
})));
export default SvgInformation;